export default {
  methods: {
    formatMoney (value) {
      return '$' + (value / 100).toFixed(2)
    }
  }
}
